var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      visible: _vm.containerVisible,
      title: _vm.$t("新建容器"),
      width: 600,
      height: 400
    },
    on: {
      ok: _vm.newContainerOk,
      cancel: _vm.cancelNewContainer
    }
  }, [_c("a-form-model", {
    ref: "containerForm",
    attrs: {
      model: _vm.containerForm,
      "label-col": {
        span: 8
      },
      rules: _vm.containerRules,
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "label-col": {
        span: 6
      },
      label: _vm.$t("容器分类")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("容器分类")
    },
    model: {
      value: _vm.containerForm.type,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "type", $$v);
      },
      expression: "containerForm.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "table"
    }
  }, [_vm._v(_vm._s(_vm.$t("数据表格")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("div", {
    staticClass: "table-sort-select-box"
  }, [_c("div", {
    class: ["table-sort-item", _vm.containerForm.tableType === "increment" ? "current-active-class" : ""],
    attrs: {
      KEY: "increment"
    },
    on: {
      click: function ($event) {
        return _vm.changeTableType("increment");
      }
    }
  }, [_c("div", {
    staticClass: "icon-part"
  }, [_c("svg-icon", {
    attrs: {
      icon: "increTable",
      size: 44
    }
  })], 1), _c("div", {
    staticClass: "desc"
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("主要应用于具有收集数据的需求，但对填写者会填写多少条数据，存在不确定的情况，此时就可使用自增表格。")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2), _c("span", [_vm._v(_vm._s(_vm.$t("自增表格")))])], 1)]), _c("div", {
    key: "fixed",
    staticClass: "table-sort-item",
    class: ["table-sort-item", _vm.containerForm.tableType === "fixed" ? "current-active-class" : ""],
    on: {
      click: function ($event) {
        return _vm.changeTableType("fixed");
      }
    }
  }, [_c("div", {
    staticClass: "icon-part"
  }, [_c("svg-icon", {
    attrs: {
      icon: "fixedTable",
      size: 44
    }
  })], 1), _c("div", {
    staticClass: "desc"
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("主要应用于行列有固定数据的表格需求，此时就可使用固定表格。")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2), _vm._v(" " + _vm._s(_vm.$t("固定表格")) + " ")], 1)])])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("列"),
      prop: "columnNum"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 0,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("列数")
    },
    model: {
      value: _vm.containerForm.columnNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "columnNum", $$v);
      },
      expression: "containerForm.columnNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("行"),
      prop: "rowNum"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 0,
      min: _vm.containerForm.tableType === "increment" ? 1 : 2,
      max: 50,
      disabled: _vm.containerForm.tableType === "increment",
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("行数")
    },
    model: {
      value: _vm.containerForm.rowNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "rowNum", $$v);
      },
      expression: "containerForm.rowNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("前")) + " "), _c("a-input-number", {
    staticStyle: {
      width: "80px",
      "margin-left": "10px"
    },
    attrs: {
      precision: 0,
      min: 1,
      max: _vm.maxTabHeaderNum,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("列数")
    },
    model: {
      value: _vm.containerForm.tableHeaderRowNum,
      callback: function ($$v) {
        _vm.$set(_vm.containerForm, "tableHeaderRowNum", $$v);
      },
      expression: "containerForm.tableHeaderRowNum"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("行为表头行")) + " ")], 1)])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };